import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw24px = 'M12.415 6.1V18H10.97v-5.559H5.275V18H3.83V6.1h1.445v5.134h5.695V6.1h1.445Zm7.023 10.744h2.176V18h-6.086v-1.156h2.516V7.749l-2.21 1.19-.544-.969 3.077-1.87h1.071v10.744Z';
const icons = {
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const TextH1Icon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'textH1'));
TextH1Icon.displayName = 'TextH1Icon';
TextH1Icon.propTypes = Icon.propTypes;
TextH1Icon.renderIcon = props => /*#__PURE__*/React.createElement(TextH1Icon, props);
export default TextH1Icon;
//# sourceMappingURL=TextH1Icon.js.map